import React from "react";
import BigButton from "@components/shared/card/BigButton";

interface MemeSwapButtonProps {
    createMemeSwap: () => Promise<any>;
    isMnemonic: boolean;
    noAddress: boolean;
    insufficientBalance?: boolean;
    noSendAmount?: boolean;
    invalidAmount?: boolean;
    onRequireMnemonicWallet?: () => void;
    isMeme: boolean;
}

const MemeSwapButton: React.FC<MemeSwapButtonProps> = ({
    createMemeSwap,
    isMnemonic,
    noAddress,
    insufficientBalance,
    noSendAmount,
    invalidAmount,
    onRequireMnemonicWallet,
    isMeme,
}) => {
    const [loading, setLoading] = React.useState(false);
    type ButtonVariant =
        | "error"
        | "default"
        | "connect"
        | "loading"
        | "fast"
        | "ton"
        | "faded"
        | "meme"
        | null
        | undefined;
    const errorStates: Array<{
        condition: boolean;
        text: string;
        disabled: boolean;
        variant: ButtonVariant;
        onClick?: () => void;
    }> = [
        {
            condition: !isMnemonic,
            text: "Select wallet",
            disabled: false,
            variant: "error",
            onClick: () => onRequireMnemonicWallet?.(),
        },
        {
            condition: !!noAddress,
            text: "No address",
            disabled: true,
            variant: "meme",
        },

        {
            condition: !!insufficientBalance,
            text: "Insufficient balance",
            disabled: true,
            variant: "meme",
        },
        {
            condition: !isMeme,
            text: "non Meme token",
            disabled: true,
            variant: "meme",
        },
        {
            condition: !!noSendAmount,
            text: "No send amount",
            disabled: true,
            variant: "meme",
        },
        {
            condition: !!invalidAmount,
            text: "Minimum amount is 0.5 TON",
            disabled: true,
            variant: "meme",
        },
    ];

    const matched = errorStates.find((e) => e.condition);

    const text = loading ? "Swapping..." : (matched?.text ?? "Swap");
    const disabled = loading || (matched?.disabled ?? false);
    const variant: ButtonVariant = loading ? "loading" : (matched?.variant ?? "meme");
    const onClick = matched?.onClick
        ? matched.onClick
        : async () => {
              setLoading(true);
              try {
                  await createMemeSwap();
              } catch (error) {
                  console.error("Error creating sniper:", error);
              } finally {
                  setLoading(false);
              }
          };

    return (
        <BigButton
            text={text}
            onClick={onClick}
            showSpaceHint={false}
            variant={variant}
            size="default"
            disabled={disabled}
            loading={loading}
        />
    );
};

export default MemeSwapButton;
